import React, { FC, useState } from 'react'
import cnBind from 'classnames/bind'
import { useStoreon } from 'storeon/react'
import {
  GxCheckbox,
  GxDropdown,
  GxIcon,
  GxMenu,
  GxMenuItem
} from '@garpix/garpix-web-components-react'
import { toast } from 'react-toastify'
import { useMediaQuery } from 'react-responsive'
import { api } from '@/api'
import { Events, State } from '@/interfaces'
import { IDayOrderSurf } from '@/types'
import {
  AccountCheckIcon,
  AnketaIcon,
  MinusIcon,
  PencilIcon,
  PlusIconRed,
  PlusIconBlue,
  VerticalIcon
} from '../../../../assets'
import styles from './styles/index.module.scss'
import { NAME_STATUS, TYPES_STATUS } from '../../consts'
import { ICustomCSSUserCard, TypeRange, TypeTable } from '../../interfaces'
import TbodyWeekContent from '../TbodyWeekTable'
import { ORDERS, TYPE_USER } from '../../../../const'
import useModal from '../../../../hooks/useModal'
import { MODALS_NAMES } from '../../../../const/modals'
import { findTariff } from '../../helpers'
import DropdownListTariff from '../DropdownListTariff/DropdownListTariff'
import ModalOrder from '../ModalOrder'
import DropdownListTemplate from '../DropdownListTemplate/DropdownListTemplate'

interface ITableItem {
  data?: IDayOrderSurf
  dataWeek?: Array<any>
  rangeType: TypeRange
  typeTable: TypeTable
  time?: string
  handleClickModal: (date: string | null, info: Record<string, any> | null) => void
}

const TableItem: FC<ITableItem> = (props) => {
  const { data, rangeType, typeTable, handleClickModal, time, dataWeek } = props
  const {
    dispatch,
    ordersInfo,
    statusCreateMultiOrders,
    arrayDateTimeOrders,
    typeOrder,
    currentUser,
    applicationInfo
  } = useStoreon<State, Events>(
    'ordersInfo',
    'statusCreateMultiOrders',
    'arrayDateTimeOrders',
    'typeOrder',
    'currentUser',
    'applicationInfo'
  )
  const cn = cnBind.bind(styles)
  const { openModal } = useModal()

  const mediaMobile = useMediaQuery({
    query: '(max-width: 715px)'
  })

  const openModalChangeComment = (id: number, comment: string): void => {
    openModal(MODALS_NAMES.modalComment, { id, comment })
  }

  const handleClickIsArrived = (id: number, flag: boolean) => {
    let response = api.order.updateOrders(id, {
      is_arrived: flag
    })
    toast
      .promise(response, {
        pending: 'Идет обновление заявки...',
        // success: `Статус прибытия заявки ${id}, успешно изменен!`,
        error: `Ошибка изменения статуса прибытия у ${id} заявки!`
      })
      .then(() => dispatch('orders/get'))
  }
  const addItemInMultiOrder = async () => {
    try {
      const actual_tariffs = await api.tariff.getActualTariff({
        time,
        date: ordersInfo.date,
        side: typeOrder
      })
      if (data) {
        let info = findTariff(
          actual_tariffs,
          typeOrder,
          applicationInfo?.customer,
          applicationInfo?.tariff_rate_multi.value,
          {
            time,
            date: ordersInfo.date
          },
          applicationInfo?.is_children
        )
        if (info.tariff && info.rate) {
          dispatch('arrayDateTimeOrders/add', {
            time: time || '',
            date: ordersInfo.date,
            data: info
          })
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  const fixPrice = (price: string): string => price.split('.')[0]

  const [valuesModal, setValuesModal] = useState<Record<string, any> | null>(null)

  const openModalOrder = (values: Record<string, any>) => {
    setValuesModal(values)
  }

  const closeModalOrder = () => setValuesModal(null)

  return (
    <>
      {rangeType === 'day' ? (
        <>
          <tr>
            <td
              style={{ border: '1px solid #B0CBFF' }}
              className={cn(styles.body_row__time, {
                [styles.body_row__restriction]: data?.is_has_session_restriction
              })}
            >
              <div className={cn(styles.body_row__time__main, styles.order__container)}>
                <span>{time}</span>
              </div>
            </td>

            <td style={{ border: 'none' }} className={styles.body_row__header}>
              <div
                style={
                  {
                    border: '1px solid #B0CBFF',
                    '--tariff-color': data?.sport_tariff !== null && data?.sport_tariff.color_code
                  } as ICustomCSSUserCard
                }
                className={styles.body_row__header__drop}
              >
                {typeOrder === ORDERS.WAVE ? (
                  <DropdownListTemplate data={data} time={time} date={ordersInfo.date} />
                ) : (
                  <DropdownListTariff data={data} time={time} />
                )}
              </div>

              <div
                className={cn(styles.body_row__header__minutes, {
                  card: data && data.have_free_session !== 0,
                  card__checked: arrayDateTimeOrders.some(
                    (item) => item.time === time && item.date === ordersInfo.date
                  )
                })}
              >
                <div className={styles.order__container}>
                  {data && (
                    <div
                      className={cn(styles.card__minutes, {
                        card__minutes__restriction: data && data.have_free_session < 0
                      })}
                    >
                      <div
                        className={cn(styles.card__minutes__text, {
                          card__minutes__count: data.is_allowed,
                          card__minutes__disabled: !data.is_allowed
                        })}
                      >
                        {`${data && data.have_free_session} ${
                          typeOrder === ORDERS.PIPE ? 'минут' : 'человек'
                        } `}
                      </div>
                      {currentUser.user_status !== TYPE_USER.VIEWER && (
                        <div className={styles.card__minutes__btn}>
                          {arrayDateTimeOrders.some(
                            (item) => item.time === time && item.date === ordersInfo.date
                          ) ? (
                            <GxIcon
                              className={cn({
                                card__minutes__btn__icon: true,
                                card__minutes__btn__icon_red: !data.is_allowed
                              })}
                              src={MinusIcon}
                              onClick={() => {
                                dispatch('arrayDateTimeOrders/delete', {
                                  time: time || '',
                                  date: ordersInfo.date
                                })
                              }}
                            />
                          ) : !data.is_allowed ? (
                            <img
                              className={cn({
                                card__minutes__btn__icon: true
                              })}
                              src={PlusIconRed}
                              onClick={() => {
                                if (statusCreateMultiOrders) {
                                  addItemInMultiOrder()
                                } else {
                                  handleClickModal(`${ordersInfo.date} ${time}`, null)
                                }
                              }}
                              alt='red plus'
                            />
                          ) : (
                            <img
                              className={cn({
                                card__minutes__btn__icon: true
                              })}
                              src={PlusIconBlue}
                              onClick={() => {
                                if (statusCreateMultiOrders) {
                                  addItemInMultiOrder()
                                } else {
                                  handleClickModal(`${ordersInfo.date} ${time}`, null)
                                }
                              }}
                              alt='blue plus'
                            />
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </td>
          </tr>

          {data?.orders.length !== 0 &&
            data?.orders.map((item: Record<string, any>) => (
              <tr key={item.id} className={styles.body_row}>
                <td>
                  {typeOrder !== ORDERS.WAVE ? (
                    <div className={styles.body_row__sessionMinutes}>
                      <div className={styles.body_row__sessionMinutes__mins}>
                        {item.session_minutes} мин.
                      </div>
                      <div className={styles.body_row__sessionMinutes__flyMins}>
                        {item.fly_session_minutes}
                      </div>
                    </div>
                  ) : (
                    <div className={styles.body_row__sessionMinutes}>{item.count_party} чел.</div>
                  )}
                </td>

                <td>
                  <div className={styles.body_row__userAndTariff}>
                    <div className={styles.body_row__userAndTariff__user}>
                      <GxCheckbox
                        name='checkbox'
                        checked={item.checked}
                        onGx-change={() => {
                          dispatch('changeCheckedOrder/set', item.id)
                        }}
                      />
                      <div className={styles.order__container}>
                        <div
                          role='button'
                          tabIndex={item.number}
                          onClick={() => handleClickModal(`${ordersInfo.date} ${time}`, item)}
                          className={styles.orders__user}
                          key={item.id}
                        >
                          {!mediaMobile && (
                            <GxIcon
                              src={AnketaIcon}
                              className={styles.orders__user_icon}
                              style={{
                                color:
                                  item.customer[
                                    ORDERS.PIPE === typeOrder
                                      ? 'acceptance_date_for_airtube'
                                      : 'acceptance_date_for_wave'
                                  ] !== null
                                    ? 'green'
                                    : 'red'
                              }}
                            />
                          )}
                          <p className={styles.orders__user_text}>
                            {item.customer.last_name} {item.customer.first_name}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        type='button'
                        onClick={() => handleClickModal(`${ordersInfo.date} ${time}`, item)}
                        className={styles.body_row__userAndTariff__tariff}
                      >
                        {item.user_deposit_or_certificate ? (
                          <>{item.user_deposit_or_certificate}</>
                        ) : (
                          <>{item.tariff_rate.tariff_name}</>
                        )}
                      </button>
                      {item.status === TYPES_STATUS.PAY_SUCCESS &&
                        !item.user_deposit_or_certificate && (
                          <p className={styles.body_row__userAndTariff__price}>
                            {fixPrice(item.price)}₽
                          </p>
                        )}
                    </div>
                  </div>
                </td>

                <td>
                  <div className={styles.order__container}>
                    <div className={styles.orders__status} key={item.id}>
                      <div
                        className={cn(
                          styles.body_row__status,
                          styles[
                            `body_row__status__${NAME_STATUS[TYPES_STATUS[item.status]].class}`
                          ]
                        )}
                      >
                        {NAME_STATUS[TYPES_STATUS[item.status]].title}
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <div className={styles.order__container__actions}>
                    <div className={styles.body_row__actions} key={item.id}>
                      <GxIcon
                        className={cn({
                          body_row__actions_icon_check: true,
                          body_row__actions_icon_check__active: item.is_arrived
                        })}
                        src={AccountCheckIcon}
                      />
                      {currentUser.user_status !== TYPE_USER.VIEWER && (
                        <GxDropdown hoist>
                          <GxIcon
                            slot={item.status !== TYPES_STATUS.CLOSE ? 'trigger' : undefined}
                            className={styles.body_row__actions_icon}
                            src={VerticalIcon}
                          />
                          <GxMenu>
                            {item.is_arrived ? (
                              <GxMenuItem onClick={() => handleClickIsArrived(item.id, false)}>
                                Не прибыл
                              </GxMenuItem>
                            ) : (
                              <GxMenuItem onClick={() => handleClickIsArrived(item.id, true)}>
                                Прибыл
                              </GxMenuItem>
                            )}
                          </GxMenu>
                        </GxDropdown>
                      )}
                    </div>
                  </div>
                </td>

                <td className={styles.body_row__message}>
                  <div className={styles.order__container}>
                    <div className={styles.comment} key={item.id}>
                      <p className={styles.comment__text}>{item.comment}</p>
                      {currentUser.user_status !== TYPE_USER.VIEWER && (
                        <GxIcon
                          src={PencilIcon}
                          className={cn({
                            comment__icon: true
                          })}
                          onClick={() => {
                            openModalChangeComment(item.id, item.comment)
                          }}
                        />
                      )}
                    </div>
                  </div>
                </td>

                <td className={styles.body_row__message}>
                  <div className={styles.order__container}>
                    <div className={styles.comment} key={item.id}>
                      <div className={styles.comment__text}>{item.user_comment}</div>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
        </>
      ) : (
        <>
          <TbodyWeekContent
            rangeType={rangeType}
            typeTable={typeTable}
            handleClickModal={handleClickModal}
            dataWeek={dataWeek}
            openModalOrder={openModalOrder}
          />
          {valuesModal && (
            <ModalOrder data={valuesModal} flag={!!valuesModal} closeModal={closeModalOrder} />
          )}
        </>
      )}
    </>
  )
}

export default TableItem
